import { Link } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import "./header.css";
import "../../style/colours.css";
import Logo from "../../assets/BlendzLogo.png";
import Phone from "../../assets/icons/phone.svg";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const headerRef = useRef<HTMLDivElement>(null); 

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (headerRef.current && !headerRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  return (
    <div className="HeaderContainer" ref={headerRef}>
      <div className="LogoContainer">
        <Link to="/">
          <img src={Logo} alt="Logo" height="50px" />
        </Link>
      </div>

      <div className="MenuIconContainer" onClick={toggleMenu}>
        <div className={`hamburger ${isMenuOpen ? 'open' : ''}`}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <menu className={`HeaderMenu ${isMenuOpen ? 'open' : ''}`}>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/beverages">Beverages</Link></li>
        <li><Link to="/dispensing">Dispensing</Link></li>
        <li><Link to="/resources">Resources</Link></li>
        <li><Link to="/faq">FAQ</Link></li>
        <li><Link to="/contact">Contact</Link></li>
        <li><Link to="/order">Order Here</Link></li>
      </menu>

      <div className="PhoneButton">
        <a href="tel:0800264948">
          <img alt="Phone Icon" src={Phone} className="PhoneIcon" />
          0800 264 948
        </a>
      </div>
    </div>
  );
}

export default Header;
